<template>
    <div>
        <div
            id="page-container"
            class="h-screen overflow-auto bg-white dark:bg-gray-800">
            <HeaderFrontend />
            <ImpersonateBanner />
            <SystemBanner />
            <BaseSlideOver
                :header-color="'primary'"
                :title="slideOverStore.title ? $t(slideOverStore.title) : ''"
                :description="slideOverStore.description ? $t(slideOverStore.description) : ''"
                :model-value="slideOverStore.isSlideOverOpen"
                @update:modelValue="slideOverStore.setSlideOverOpen($event)"
                @close-slide-over="closeSlideOver">
                <Component :is="components[slideOverStore.component]" />
            </BaseSlideOver>
            <main>
                <ComingSoonPage
                    v-if="underConstruction"
                    hide-dashboard-link />
                <div v-else>
                    <CmsFrontendAlert />

                    <slot />
                </div>

                <ScrollBackToTopButton />
            </main>
            <FooterFrontend />
        </div>
    </div>
</template>

<script setup>
import {useNuxtApp} from "nuxt/app"
import FundingProgramsSelection from "@/components/global/FundingPrograms/FundingProgramsSelection"
import HeaderFrontend from "@/components/layouts/HeaderFrontend"
import AuthWrapper from "@/components/pages/auth/AuthWrapper.vue"
import {useNotification} from "@/composables/useNotification"
import {useAuthStore} from "@/store/auth"
import {useCmsNavItemsStore} from "@/store/cmsNavItems"
import {useSlideOverStore} from "@/store/slideOver"
import {useWebsocketStore} from "@/store/websockets"
import {$larafetch} from "@/utils/$larafetch"

const authStore = useAuthStore()
const slideOverStore = useSlideOverStore()
const route = useRoute()
const notification = useNotification()
const app = useNuxtApp()
const {t: $t} = useI18n()

const sportbizzRefreshInterval = ref(null)

const components = {
    FundingProgramsSelection,
    AuthWrapper,
}

const underConstruction = computed(() => useRuntimeConfig()?.public?.underConstruction)

onMounted(() => {
    if (route.query?.resetPassword === "true") {
        slideOverStore.setSlideOverOpen(true)
        slideOverStore.setTitle('auth.resetPassword')
        slideOverStore.setDescription('')
        slideOverStore.setComponent('AuthWrapper')
        slideOverStore.setContext(null)
        slideOverStore.setBeforeClosing(redirectToHome)
    }

    if (route.query?.verified == 1) {
        notification.success($t('auth.emailVerified'))
    }

    if (authStore.userData) {
        useWebsocketStore().init()
    }

    useCmsNavItemsStore().fetchCmsNavItems()

    // sportbizz refresh
    if (authStore.userData && authStore.userData.is_sportbizz === true) {
        sportbizzRefreshInterval.value = setInterval(function () {
            $larafetch(app.$apiRoute('sportbizz.refresh'), {
                method: 'GET',
            }).then(response => {
            }).catch(e => {
                notification.error(app.$i18n.t('sportbizz.refresh.error'), e.data.message)

                if (e.response.status === 401) {
                    authStore.resetAuthData()
                    navigateTo({
                        path: '/'
                    })
                }

                console.error(e)
            })
        }, 60000)
    }
})

watch(() => authStore.isAuthenticated, () => {
    if (!authStore.isAuthenticated && sportbizzRefreshInterval.value) {
        clearInterval(sportbizzRefreshInterval.value)
    }
})

useHead({
    bodyAttrs: {
        class: 'h-full bg-gray-50'
    },
    htmlAttrs: {
        class: 'h-full'
    }
})

onBeforeUnmount(() => {
    if (sportbizzRefreshInterval.value) {
        clearInterval(sportbizzRefreshInterval.value)
    }
})

function redirectToHome() {
    navigateTo({path: '/', query: {}})
}

function closeSlideOver() {
    if (slideOverStore.beforeClosing && typeof slideOverStore.beforeClosing === 'function') {
        slideOverStore.beforeClosing()
    }

    slideOverStore.resetSlideOver()
}
</script>
